import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Layout from "@/night/Layout";
import Home from "@/night/Home";
import Departments from "@/night/Departments";
import Rules from "@/night/Rules";
import RuleDetail from "@/night/RuleDetail";
import Cars from "@/night/Cars";
import { Businesses, Gangs, Packages } from "@/night/Store";
import { Contact, Leaderboard, News, Staff } from "@/night/Info";
import { Apply, ApplyDept } from "@/night/Apply";
import Admin from "@/pages/admin/Admin";
import Tools from "@/pages/Tools";
import NotFound from "@/night/NotFound";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
      <Routes>
        <Route path="/tools" element={<Tools />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/departments" element={<Departments />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/rules/:slug" element={<RuleDetail />} />
          <Route path="/news" element={<News />} />
          <Route path="/cars" element={<Cars />} />
          <Route path="/businesses" element={<Businesses />} />
          <Route path="/gangs" element={<Gangs />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/:slug" element={<ApplyDept />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
